
<template>
  <div class="wrapper">
    <el-input placeholder="请输入到货数量" type="number" v-model="arrival_quantity">
      <template slot="prepend">到货数量</template>
    </el-input>

    <div class="check-box">
      <el-form ref="form" :model="form" label-width="50px">
        <template v-if="fast_remark">
          <el-form-item label="备注">
            <el-input v-model="form.remark"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="备注">
            <el-select v-model="form.remark" clearable placeholder="请选择快速备注信息">
              <el-option label="定制文案错误" value="定制文案错误"></el-option>
              <el-option label="尺码错误" value="尺码错误"></el-option>
              <el-option label="确认文案正确" value="确认文案正确"></el-option>
              <el-option label="产品破损" value="产品破损"></el-option>
              <el-option label="文案不全" value="文案不全"></el-option>
              <el-option label="文案模糊" value="文案模糊"></el-option>
              <el-option label="到货1个" value="到货1个"></el-option>
              <el-option label="到货2个" value="到货2个"></el-option>
              <!--<el-option label="定制信息错误" value="定制信息错误"></el-option>-->
              <!--<el-option label="产品破损" value="产品破损"></el-option>-->
              <!--<el-option label="数量不对" value="数量不对"></el-option>-->
              <!--<el-option label="印刷质量差" value="印刷质量差"></el-option>-->
              <!--<el-option label="其它" value="其它"></el-option>-->
              <!--<el-option label="移除备注" value=""></el-option>-->
            </el-select>
          </el-form-item>
        </template>

        <div style="position: relative">

          <div class="remark-button">
            <el-button type="info" size="small" @click.prevent="fast_remark=!fast_remark" v-if="fast_remark">切换到快速备注
            </el-button>
            <el-button type="warning" size="small" @click.prevent="fast_remark=!fast_remark" v-else>切换到自定义备注</el-button>
          </div>

          <!--上传图片-->
          <el-upload
              class="upload-demo"
              action="#"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              list-type="picture"
              :limit="3"
              :on-success="handleSuccess"
              :auto-upload='false'
              :on-change="handleChange"
              :on-exceed="handleExceed"
          >
            <el-button size="small" type="primary" style="margin-left: 10px" >上传图片</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过3张</div>
          </el-upload>
        </div>




      </el-form>
    </div>
    <el-row style="display:flex">
      <el-button type="danger" @click="arrivalHand(2)" style="margin: 31px 0px 0 0px;width: 80%;">异 常</el-button>
      <el-button type="primary" @click="arrivalHand(1)" style="margin: 31px 0px 0 20px;width: 80%;">完 成</el-button>
    </el-row>
  </div>

</template>


<script>
import {getToken} from "@/utils/auth";
import {uploadImage} from "../../../utils/fileUpload";
export default {
  name: "ArrivalQuantity",
  props: ['quantity'],
  data(){
    return{
      arrival_quantity:'',
      fast_remark: false,
      form: {
        remark: '',
      },
      fileList: [],
      imgList: [],
      headers: {
        Authorization: getToken(),
      },
      uploadImgUrl: this.api.file_upload, // 上传图片的后台controller的地址
    }
  },
  methods:{
    arrivalHand(status){
      if(status == 2){
        if (this.form.remark == null || this.form.remark === '') {
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 3000,
            message: h('p', null, [
              h('span', null, '异常订单请填写备注信息 '),
            ])
          });
          return false;
        }
      }


      if(this.arrival_quantity<=0||this.arrival_quantity>=this.quantity||this.arrival_quantity==''){
        alert('请输入正确的数量');
      }else{
        console.log('备注：'+this.form.remark);
        console.log(this.fileList);
        console.log('数量：'+this.arrival_quantity);
        console.log('状态：'+status);
        this.$emit('arrivalHand',false,this.arrival_quantity,status,this.fileList,this.form.remark);
      }


    },
    // 图片上传
    handleSuccess(response, file, fileList) {
      console.log(response)
      console.log(file)
      console.log(fileList)
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
      let param = {
        filename: file.filename
      }

      if (file.id !== undefined) {
        param.id = file.id
      }

      // 执行图片删除
      this.http.fetchDel(this.api.file_delete, param).then(res => {
        console.log(res)
      }).catch(err => {
        console.log(err);
      })

      this.fileList = fileList

      console.log(this.fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(){
      this.$message.error('最多只能上传3张图片');
    },
    handleChange(file, fileList) {
      console.log(file)
      console.log(fileList);

      this.loading=true

      // 使用 FormData
      let fd = new FormData();
      fd.append('file', file.raw);

      // 二次封装的 axios
      uploadImage(this.api.file_upload, fd).then(res => {
        // console.log(res);
        if (res.code === 200) {
          this.imgList.push(res.data.filename)

          for (var i = 0; i < fileList.length; i++) {

            if (fileList[i].uid === file.uid) {

              fileList[i].filename = res.data.filename

            }

          }

          this.fileList = fileList

          this.loading=false

        }
        // console.log(this.imgList);
        // console.log(this.fileList);
      });
    },

  },
}
</script>

<style scoped lang="stylus">
.check-box {
  margin-top 5px
  .el-select {
    width 100%
  }
}
.remark-button
  position absolute
  top 0
  left 110px

</style>
